import { Component, OnInit, ElementRef, Renderer2, ViewChild, Input } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { CommonService } from '../../../common/services/common.service';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import {
  ProfileRequest,
  Settings, Sku, CustomizableButtonData, ProfileUpdateResponse
} from '../../create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { Utils } from '../../../common/utils/utils';
import { AppGlobal } from '../../../../../src/app/core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import moment from 'moment';
import { SkuIdInfoService } from '../../../../app/core/routing/services/sku-ids/sku-id-info.service';
import * as XLSX from 'xlsx';
import { HttpMethodsService } from '../../../core/routing/services/_helpers/http-methods.service';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/internal/operators/map';
@Component({
  selector: 'iposcen-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  @Input() iposliteEnabled: boolean;
  @ViewChild('profileChangePasswordModal') profileChangePasswordModal: ElementRef;
  profileDataSet: ProfileRequest;
  settingsFrm: FormGroup;
  sku: Sku[];
  skuList: any[];
  fileName: string;
  profileID: string;
  file: any = {};
  skuValidationError = false;
  showcsvError = false;
  csvTemplateError: boolean;
  isSkuCodeAvailable: boolean;
  isSkuCodeDuplicate: boolean;
  isBatteryPositive: boolean;
  isSkuCodeAvailableError: boolean;
  isSkuCodeDuplicateError: boolean;
  isBatteryLifeError: boolean;
  downloadFile = new Date().toLocaleDateString() + '_' + GlobalConstants.SKU_CSV_FILENAME + '.csv';
  messageModalPopup: boolean;
  passwordType: string;
  deviceSpecifications: boolean = true;
  linkToURL: boolean = false;
  url: string = '';
  exploreThisPC: boolean = true;
  compareNavigationText: string;
  customButtonCopyText: string = '';
  animationButton: boolean = false;
  customBtnCopy: boolean = false;
  settings: any; //can't use interface since assigning blank for new profile. 
  isURLValid: boolean = true;
  enabled: string = GlobalConstants.ENABLED;
  disabled: string = GlobalConstants.DISABLED;
  uninstall: string = GlobalConstants.UNINSTALL;
  primary: string = GlobalConstants.PRIMARY;
  buttonCopyPlaceholderText = $localize`:@@setting.input-placeholder.enter-button-copy-here:Enter button copy here`;
  enterURLPlacholderText = $localize`:@@setting.input-placeholder.enter-url-here:Enter URL here`;
  deviceSpecificationInfo = $localize`:@@settings.device-specification.device-specification-info:Display a summary of this device’s specifications.`;
  linkToUrlInfo = $localize`:@@settings.link-to-url.link-to-url-info:Make sure this device has internet access so that customers can access the website.`;
  emailValidationMsg: string = GlobalConstants.EMAIL_VALIDATION_MSG;
  uploadCSVNote = GlobalConstants.UPLOAD_CSV_NOTE;
  uploadedCSVError = GlobalConstants.UPLOAD_CSV_ERROR;
  uploadedCSVTemplateError = GlobalConstants.UPLOAD_CSV_FORMAT_ERROR_MSG;
  userRole: string;
  isRepairabilityIndexEnabled: boolean;
  retailerConfig: any;
  repairabilityPositive: boolean;
  isRepairabilitySizeError: boolean;
  isRepairabilityDecimal: boolean;
  riPositiveValueChecker: number;
  riRangeErrorChecker: number;
  dasTeteDecimalPointChecker: number;
  dasTroncDecimalPointChecker: number;
  dasMembreDecimalPointChecker: number;
  isChromebookSelected: boolean = false;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  dasDecimalPointValidationMsg = GlobalConstants.DAS_DECIMALPOINT_VALIDATION_DESC;
  showMasterPwdStatus = false;
  showUnInstallPwdStatus = false;
  isAutoShutdownEnabled: boolean;
  enableTimeZone: any;
  editPublishDateInfo: string;
  isSettingsTimeZoneSelected = true;
  settingsTimezoneObj: any;
  sendDefaultTimeZone: string;
  isPriceSupress: boolean;
  valueForSKU: any;
  selectedSKUs: any = [];
  fetchedSKUs: any = [];
  globalconst = GlobalConstants;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  checkingSet = GlobalConstants.skuChkSet;
  selectAllSku: boolean = false;
  isDataLoading: boolean = true;
  isSelectAllClicked = false;
  isAllSelectedData = new Map();
  isMasterSel = false;
  isAlldevicesSelected: boolean;
  downloadTemplateText = GlobalConstants.IPOS_LITE_DOWNLOAD_SAMPLE_TEMPLATE;
  uploadTemplateText = GlobalConstants.IPOS_LITE_UPLOAD_PRODUCT_MAP;
  templateNoteText = GlobalConstants.UPLOAD_CSV_NOTE;
  showFileContentError: boolean;
  showXlsxError: boolean;
  PMFileExists: boolean;
  templateName: string = 'ProductMapping.xlsx';
  uploadedDate: any;
  private ngUnsubscribe = new Subject<boolean>();
  llmExcelDemoJson: any = [];
  llmExcelMessagesJson: any = [];
  llmExcelLaptopJson: any = [];
  llmExcelSpecificationJson: any = [];
  llmExcelTopicJson: any = [];
  constructor(private cmnService: CommonService,
    private profileStoreService: ProfileStoreService,
    private formBuilder: FormBuilder,
    private createProfileService: CreateProfileService,
    private appGlobal: AppGlobal,
    private googleAnalyticsService: GoogleAnalyticsService,
    private skuIdService: SkuIdInfoService,
    private elRef: ElementRef, private renderer: Renderer2,
    private httpMethodsservice: HttpMethodsService
  ) { }

  ngOnInit(): void {
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount.role;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId, this.retailerId);
          this.isRepairabilityIndexEnabled = this.retailerConfig.isRepairabilityIndexEnabled;
          this.isAutoShutdownEnabled = this.retailerConfig?.isAutoShutdown;
          this.isPriceSupress = this.retailerConfig?.isPriceSupress;
        }
        await this.getAllSKU();
        this.loadSettingsData();
        if (this.iposliteEnabled) this.getUploadedFile();
      });
    //To open success message popup after change Password PATCH
    this.cmnService.passwordChangeSuccessObser.subscribe((data) => {
      this.messageModalPopup = true;
      this.loadSettingsData();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  loadSettingsData() {
    this.profileDataSet = this.profileStoreService.currentWorkingProfile;
    if (this.profileDataSet && this.profileDataSet?.profileId && this.profileDataSet?.settings) {
      this.settings = JSON.parse(this.profileDataSet?.settings) as Settings;
      if (this.settings?.compareTabText === undefined) this.compareNavigationText = GlobalConstants.COMPARE_TAB_DEFAULT_TEXT;
      else this.compareNavigationText = this.settings?.compareTabText;
      this.editPublishDateInfo = this.settings?.otherSettings?.autoShutDown ? this.generateTimeTimeZoneData(this.settings?.otherSettings?.autoShutDown) : '';
      if (
        this.settings?.customizableButton?.buttonFunctionality?.customButtonCopyText ===
        GlobalConstants.EXPLORE_THIS_PC_CAPS
        &&
        this.settings?.customizableButton.buttonFunctionality.type !== GlobalConstants.urlStr
      ) {
        this.settings.customizableButton.buttonFunctionality.customButtonCopyText = '';
      }
    }
    if (this.settings?.otherSettings?.operatingSystem === GlobalConstants.CHROME_TYPE) {
      this.isChromebookSelected = true;
    }
    if (!this.settings?.otherSettings?.oldSkuList &&
      this.settings?.otherSettings?.skuList?.length &&
      this.settings.otherSettings?.skuFileName &&
      this.settings.otherSettings?.skuFileName != '') {
      this.settings.otherSettings.oldSkuList = JSON.parse(JSON.stringify(this.settings?.otherSettings?.skuList)); // Copy skuList data to oldSkuList
      this.settings.otherSettings.skuList = [];
    }
    if (this.settings?.otherSettings?.skuList?.length) {
      for (let i = 0; i < this.settings?.otherSettings?.skuList?.length; i++) {
        this.selectedSKUs.push(this.settings?.otherSettings?.skuList[i].skuID);
        this.isAllSelectedData.set(this.skuList[i].skuID, this.skuList[i]);
      }
    }
    if (this.settings?.otherSettings?.selectedAllSKUs) {
      if (this.arrayEquals(this.selectedSKUs, this.fetchedSKUs) == false) {
        this.settings.otherSettings.selectedAllSKUs = false;
      } else {
        this.settings.otherSettings.selectedAllSKUs = true;
        this.isAlldevicesSelected = true;
      }

    } else {
      this.settings.otherSettings.selectedAllSKUs = false;
    }
    this.isDataLoading = false;
    this.createSettingsForm();
  }
  openModal(modal: any, type: string) { modal.open(type); }

  closeModal(modal: any) {
    modal.close();
  }

  closeMessageModal() {
    this.messageModalPopup = false;
  }

  //Initiate settings form
  createSettingsForm() {
    this.settingsFrm = this.formBuilder.group({
      priceEntryInstallation: (this.settings?.otherSettings.priceEntryInstallation) ?
        new FormControl(true) : this.settings?.otherSettings.priceEntryInstallation,
      enableVA: this.settings?.otherSettings.enableVA ? this.settings?.otherSettings.enableVA : new FormControl(false),
      allowNonIntel: (this.settings?.otherSettings.allowNonIntel) ?
        new FormControl(true) : this.settings?.otherSettings.allowNonIntel,
      desktopPasswordProtection: this.settings?.otherSettings.desktopPasswordProtection ?
        this.settings?.otherSettings.desktopPasswordProtection :
        new FormControl(false),
      autoShutDown: this.settings?.otherSettings?.autoShutDown?.autoShutDownTimeEnabled ?
        this.settings?.otherSettings?.autoShutDown?.autoShutDownTimeEnabled : new FormControl(false)
    });

    //can't use these as part of form. Because radio buttons can't be grouped using formControlName
    if (this.settings?.customizableButton) {
      this.animationButton = this.settings?.customizableButton.animationButton;
      if (this.settings?.customizableButton.buttonFunctionality.type === GlobalConstants.urlStr) {
        this.url = this.settings?.customizableButton.buttonFunctionality.url;
        this.linkToURL = true;
      }
      this.customButtonCopyText = this.settings?.customizableButton?.buttonFunctionality?.customButtonCopyText;
      if (this.settings?.customizableButton.buttonFunctionality.type !== GlobalConstants.urlStr &&
        this.customButtonCopyText?.length) {
        this.exploreThisPC = false;
        this.customBtnCopy = true;
      }
    }
  }

  //Function to get formControls. instead of this.form.controls just formCont. can be used.
  get formCont() {
    return this.settingsFrm.controls;
  }

  //For change master/uninstall password
  openChangePasswordModal(type: string) {
    this.passwordType = type; // To show in success message
    this.openModal(this.profileChangePasswordModal, type);
  }

  //Function to set flags onChange
  updateSettingsFlags(event: any, key: string) {
    if (key === GlobalConstants.LINK_TO_URL) {
      this.deviceSpecifications = false;
      this.linkToURL = true;
      this.customButtonCopyText = this.settings?.customizableButton?.buttonFunctionality?.customButtonCopyText ?
        this.settings?.customizableButton?.buttonFunctionality?.customButtonCopyText : '';
    }
    else if (key === GlobalConstants.DEVICE_SPECIFICATIONS) {
      this.deviceSpecifications = true;
      this.linkToURL = false;
      this.customButtonCopyText = '';
    }
    else if (key === GlobalConstants.EXPLORE_THIS_PC) {
      this.exploreThisPC = true;
      this.customBtnCopy = false;
      this.customButtonCopyText = '';
    }
    else if (key === GlobalConstants.CUSTOM_BTN_COPY) {
      this.customBtnCopy = true;
      this.exploreThisPC = false;
      this.customButtonCopyText = '';
    }
  }

  //To send it to backend and to move into next tab
  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND) {
      this.settingsTimezoneObj = {
        autoShutDownHour: this.formCont?.autoShutDown?.value ? (this.enableTimeZone?.hour || this.settings?.otherSettings?.autoShutDown?.autoShutDownHour) : '00',
        autoShutDownMin: this.formCont?.autoShutDown?.value ? (this.enableTimeZone?.min || this.settings?.otherSettings?.autoShutDown?.autoShutDownMin) : '00',
        autoShutDownTimeZone: this.formCont?.autoShutDown?.value ? (this.enableTimeZone?.timeZone || this.settings?.otherSettings?.autoShutDown?.autoShutDownTimeZone) : this.sendDefaultTimeZone,
        autoShutDownTimeEnabled: this.formCont?.autoShutDown?.value
      };
      let otherSettings = {
        priceEntryInstallation: this.formCont.priceEntryInstallation.value,
        enableVA: this.formCont.enableVA.value || false,
        allowNonIntel: this.formCont.allowNonIntel.value,
        desktopPasswordProtection: this.formCont.desktopPasswordProtection.value,
        autoShutDown: this.settingsTimezoneObj,
        skuList: this.getSlectedSKUSetData() // Function to convert new SKU structure to profile SKU sturucture
      };
      //preparing compareSKUAssets
      if (otherSettings?.skuList?.length) {
        let compareSKUAssetObjs = {};
        for (let i = 0; i < otherSettings?.skuList?.length; i++) {
          if (otherSettings?.skuList[i]?.compare && otherSettings?.skuList[i]?.compare?.uploadImageURL && otherSettings?.skuList[i]?.compare?.uploadImageURL != '') {
            compareSKUAssetObjs[otherSettings?.skuList[i].skuID] = otherSettings?.skuList[i].skuID + "." + otherSettings?.skuList[i]?.compare?.uploadImageURL.substring(otherSettings?.skuList[i]?.compare?.uploadImageURL.lastIndexOf('.') + 1);
          }
          for (let each in otherSettings?.skuList[i]?.skuCompareList) {
            if (otherSettings?.skuList[i]?.skuCompareList[each]?.compare && otherSettings?.skuList[i]?.skuCompareList[each]?.compare?.uploadImageURL && otherSettings?.skuList[i]?.skuCompareList[each]?.compare?.uploadImageURL != '') {
              compareSKUAssetObjs[otherSettings?.skuList[i]?.skuCompareList[each].skuId] = otherSettings?.skuList[i]?.skuCompareList[each].skuId + "." + otherSettings?.skuList[i]?.skuCompareList[each]?.compare?.uploadImageURL.substring(otherSettings?.skuList[i]?.skuCompareList[each]?.compare?.uploadImageURL.lastIndexOf('.') + 1);
            }
          }
        }
        let compareSKUAssetObjsArray = [];
        for (let j in compareSKUAssetObjs) { //converting json object into array
          compareSKUAssetObjsArray.push({ [j]: compareSKUAssetObjs[j] });
        }
        otherSettings[GlobalConstants.COMPARE_SKU_ASSET] = compareSKUAssetObjsArray;
      }

      const custBtnCopyText = this.customButtonCopyText;
      let settingsDataSet: CustomizableButtonData = {
        customizableButton: {
          animationButton: this.animationButton,
          buttonFunctionality: {
            type: this.deviceSpecifications ? GlobalConstants.DeviceSpec : GlobalConstants.urlStr,
            url: this.url,
            customButtonCopyText: (this.deviceSpecifications && !this.customButtonCopyText.trim()?.length) ?
              GlobalConstants.EXPLORE_THIS_PC_CAPS : custBtnCopyText.trim()
          }
        }
      };

      //setting URL to blank always when user selects type as device_specfications
      if (settingsDataSet.customizableButton.buttonFunctionality.type === GlobalConstants.DeviceSpec) {
        settingsDataSet.customizableButton.buttonFunctionality.url = "";
      }

      const compareTabText = this.compareNavigationText;
      this.settings.compareTabText = compareTabText.trim();

      //combine this with existing data
      this.settings.otherSettings = Object.assign(this.settings?.otherSettings, otherSettings);

      //remove oldSkulist if there are no new SKUs
      if (!this.settings.otherSettings?.skuList?.length && this.settings.otherSettings?.oldSkuList) {
        this.settings.otherSettings.skuList = this.settings.otherSettings?.oldSkuList;
        delete this.settings.otherSettings?.oldSkuList;
      }

      // For UAT-464, Adding flags for removing default passwords for the packages generated in the current year.
      if (!this.showMasterPwdStatus && !this.showUnInstallPwdStatus) {
        this.settings.isMasterPwdChanged = 'false';
        this.settings.isUninstallPwdChanged = 'false';
        this.settings.masterPwd = this.settings.masterPwd || '';
        this.settings.uninstallPwd = this.settings.uninstallPwd || '';
      } else if (this.showMasterPwdStatus && !this.showUnInstallPwdStatus) {
        this.settings.isMasterPwdChanged = 'true';
        this.settings.uninstallPwd = this.settings.uninstallPwd || '';
        this.settings.isUninstallPwdChanged = 'false';
      } else if (this.showUnInstallPwdStatus && !this.showMasterPwdStatus) {
        this.settings.isUninstallPwdChanged = 'true';
        this.settings.masterPwd = this.settings.masterPwd || '';
        this.settings.isMasterPwdChanged = 'false';
      } else if (this.showMasterPwdStatus && this.showUnInstallPwdStatus) {
        this.settings.isMasterPwdChanged = 'true';
        this.settings.isUninstallPwdChanged = 'true';
      }
      this.settings = Object.assign(this.settings, settingsDataSet);
      this.cmnService.emitDataToProfile({
        page: GlobalConstants.SETTINGS,
        dataSet: this.settings as Settings
      });
      let skus = this.settings.otherSettings.selectedAllSKUs ? this.settings.otherSettings.skuList : this.selectedSKUs;
      this.googleAnalyticsService.profileSkuInformation(this.profileDataSet.profileId, this.profileDataSet.profileName, skus);

    } else {
      this.cmnService.emitDataToProfile({
        page: GlobalConstants.SETTINGS,
        dataSet: GlobalConstants.SKIP
      });
    }
  }

  downloadTemplate() {
    let tempHeaders = Object.keys(this.composeCSVHeaders()).join(',');
    let todayTime = new Date();
    let month = (todayTime.getMonth() + 1);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let filename = GlobalConstants.SKU_CSV_FILENAME;
    let userfilename = month + '_' + day + '_' + year + '_' + filename;
    this.downloadExcel(tempHeaders, userfilename + '.csv');
  }

  onFilechange(fileInput: any) {
    this.resetValidationChecker();
    this.skuValidationError = false;
    this.fileName = fileInput.target.files[0].name;
    const fileType = this.fileName.split('.').pop();
    if ((fileType || '').toLowerCase() !== GlobalConstants.FILE_TYPE_CSV) {
      this.showcsvError = true;
      return;
    } else {
      this.showcsvError = false;
    }
    const reader = new FileReader();
    reader.readAsText(fileInput.target.files[0], GlobalConstants.ENCODING_TYPE);
    reader.onload = _event => {
      this.getParseCSVdata(reader.result);
    };
    this.file = fileInput.target.files[0];
    fileInput.target.value = null;
    this.settings.otherSettings.skuFileName = this.fileName;

  }

  resetValidationChecker() {
    this.riPositiveValueChecker = 0;
    this.riRangeErrorChecker = 0;
    this.dasTeteDecimalPointChecker = 0;
    this.dasTroncDecimalPointChecker = 0;
    this.dasMembreDecimalPointChecker = 0;
  }

  getParseCSVdata(data) {
    let csvArray = data.split('\n');
    let csvJsonObj = [];
    let csvData = [];
    const headersCsv = csvArray[0].replace('\r', '').split(',');
    const headerCsvObj = {
      headerCsvInput: []
    };
    headerCsvObj.headerCsvInput.push(GlobalConstants.SKU_CODE);
    headerCsvObj.headerCsvInput.push(GlobalConstants.BATTERY_LIFE);
    if (!this.isPriceSupress) {
      headerCsvObj.headerCsvInput.push(GlobalConstants.PRIMARY_PRICE);
      headerCsvObj.headerCsvInput.push(GlobalConstants.SECONDARY_PRICE);
      headerCsvObj.headerCsvInput.push(GlobalConstants.PRICE_STRIKETHROUGH);
    }
    headerCsvObj.headerCsvInput.push(GlobalConstants.SEGMENT_ID_CSV);
    headerCsvObj.headerCsvInput.push(GlobalConstants.PROMOCONTENT_1);
    headerCsvObj.headerCsvInput.push(GlobalConstants.PROMOCONTENT_2);
    headerCsvObj.headerCsvInput.push(GlobalConstants.PROMOCONTENT_3);
    if (this.isRepairabilityIndexEnabled) {
      headerCsvObj.headerCsvInput.push(GlobalConstants.REPAIRABILITY_INDEX_COL_NAME);
      headerCsvObj.headerCsvInput.push('DAS tête');
      headerCsvObj.headerCsvInput.push('DAS tronc');
      headerCsvObj.headerCsvInput.push('DAS membre');
    }
    // Logic to check whether CSV template columns are in order
    this.csvTemplateError = headersCsv.length === headerCsvObj.headerCsvInput.length
      && this.compareSKUCSVArrays(headersCsv, headerCsvObj.headerCsvInput) ? false : true;

    let csvHeadersObj = {
      csvHeaders: []
    }
    csvHeadersObj.csvHeaders.push('skuCode');
    csvHeadersObj.csvHeaders.push('batteryLife');
    if (!this.isPriceSupress) {
      csvHeadersObj.csvHeaders.push('primaryPrice');
      csvHeadersObj.csvHeaders.push('secondaryPrice');
      csvHeadersObj.csvHeaders.push('priceStrikethrough');
    }
    csvHeadersObj.csvHeaders.push('segmentID');
    csvHeadersObj.csvHeaders.push('promotion_content_group_1_ID');
    csvHeadersObj.csvHeaders.push('promotion_content_group_2_ID');
    csvHeadersObj.csvHeaders.push('promotion_content_group_3_ID');
    if (this.isRepairabilityIndexEnabled) {
      csvHeadersObj.csvHeaders.push('repairabilityIndex');
      csvHeadersObj.csvHeaders.push('das_tete');
      csvHeadersObj.csvHeaders.push('das_tronc');
      csvHeadersObj.csvHeaders.push('das_membre');
    }
    for (var i = 1; i < csvArray.length; i++) {
      if ((csvArray[i].split(',').length === 1) && (csvArray[i].length === 0)) {
        csvArray.pop(i);
      }
    }
    this.isSkuCodeAvailableError = csvArray[1] ? false : true;
    for (var i = 1; i < csvArray.length; i++) {
      csvData = csvArray[i].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/g);
      var csvObj = {};
      let promoContentArray = [];
      let primaryPriceValue = "";
      let secondaryPriceValue = "";
      let repairabilityIndexValue = "";
      let dasTeteValue = "";
      let dasTroncValue = "";
      let dasMembreValue = "";
      for (var j = 0; j < csvData.length; j++) {
        if (csvHeadersObj.csvHeaders[j] === "promotion_content_group_1_ID"
          || csvHeadersObj.csvHeaders[j] === "promotion_content_group_2_ID"
          || csvHeadersObj.csvHeaders[j] === "promotion_content_group_3_ID") {
          let promoData = csvData[j].replace(/\n|\r/g, "");
          if (promoData !== "") {
            promoContentArray.push(promoData);
          }
        }
        else if (csvHeadersObj.csvHeaders[j] === "primaryPrice" && csvData[j] !== "") {
          csvData[j] = csvData[j].replace(/"/g, '').trim();
          primaryPriceValue = csvData[j];
        } else if (csvHeadersObj.csvHeaders[j] === "secondaryPrice" && csvData[j] !== "") {
          csvData[j] = csvData[j].replace(/"/g, '').trim();
          secondaryPriceValue = csvData[j];
        } else if (csvHeadersObj.csvHeaders[j] === "repairabilityIndex" && csvData[j] !== "") {
          csvData[j] = csvData[j].replace(/"/g, '').trim();
          repairabilityIndexValue = csvData[j];
        } else if (csvHeadersObj.csvHeaders[j] === "skuCode" && csvData[j] !== "") {
          //Removing first and last quote and replacing double with single to handle - Laptop 14"
          csvData[j] = csvData[j].replace(/(^")|("$)/g, '').replace('""', '"');
          csvObj["skuCode"] = csvData[j].replace(/\u00A0/g, " ").trim();
        } else if (csvHeadersObj.csvHeaders[j] === "das_tete" && csvData[j] !== "") {
          csvData[j] = csvData[j].replace(/"/g, '').trim();
          dasTeteValue = csvData[j];
        } else if (csvHeadersObj.csvHeaders[j] === "das_tronc" && csvData[j] !== "") {
          csvData[j] = csvData[j].replace(/"/g, '').trim();
          dasTroncValue = csvData[j];
        } else if (csvHeadersObj.csvHeaders[j] === "das_membre" && csvData[j] !== "") {
          csvData[j] = csvData[j].replace(/"/g, '').trim();
          dasMembreValue = csvData[j];
        } else {
          csvObj[csvHeadersObj.csvHeaders[j]?.trim()] = csvData[j].trim();
        }
      }
      csvObj["promotionalContentIDs"] = promoContentArray;
      csvObj["primaryPrice"] = primaryPriceValue;
      csvObj["secondaryPrice"] = secondaryPriceValue;
      csvObj["repairabilityIndex"] = repairabilityIndexValue;
      csvObj["das_tete"] = dasTeteValue;
      csvObj["das_tronc"] = dasTroncValue;
      csvObj["das_membre"] = dasMembreValue;
      csvJsonObj.push(csvObj);
    }
    if (csvJsonObj.length > 0) {
      this.validateCSVRows(csvJsonObj);
    }
    else {
      this.resetValidationChecker();
    }
    let duplicateSku = [];
    var csvJsonObj1 = csvJsonObj.map(item => { return item.skuCode });
    csvJsonObj1.forEach((item, idx) => {
      this.isSkuCodeDuplicate = csvJsonObj1.indexOf(item) != idx ? true : false;
      if (this.isSkuCodeDuplicate) {
        duplicateSku.push(item);
      }
    });
    this.isSkuCodeDuplicateError = duplicateSku.length > 0 ? true : false;
    let batteryLife = []
    let skuUnAvailability = [];
    csvJsonObj.forEach(item => {
      if (item.batteryLife) {
        this.isBatteryPositive = item.batteryLife > 0 ? false : true;
        if (this.isBatteryPositive) {
          batteryLife.push(item.batteryLife)
        }
      }
      this.isSkuCodeAvailable = item.skuCode ? false : true;
      if (this.isSkuCodeAvailable) {
        skuUnAvailability.push(item.skuCode)
      }
    });
    this.isBatteryLifeError = batteryLife.length > 0 ? true : false;
    if (csvArray[1]) {
      this.isSkuCodeAvailableError = skuUnAvailability.length > 0 ? true : false;
    }

    if ((!(this.isSkuCodeDuplicateError || this.isSkuCodeAvailableError || this.isBatteryLifeError || (this.riPositiveValueChecker > 0) || (this.riRangeErrorChecker > 0) || (this.dasTeteDecimalPointChecker > 0) || (this.dasTroncDecimalPointChecker > 0) || (this.dasMembreDecimalPointChecker > 0))) && !this.showcsvError && !this.csvTemplateError) {
      this.skuValidationError = true;
      let inputParams = {
        skuList: csvJsonObj
      }
      this.profileID = this.createProfileService.getProfileId();

      this.settings.otherSettings = Object.assign(this.settings.otherSettings, inputParams);

      this.createProfileService.updateProfile(this.profileID, { settings: JSON.stringify(this.settings) })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          const updateProfileStoreLogo = data.profile as ProfileUpdateResponse;
          this.profileStoreService.updateProfileData(updateProfileStoreLogo);
        })
      this.googleAnalyticsService.skucsvUpload(inputParams.skuList.length, inputParams.skuList); // IIT2-5312
    } else {
      this.file = undefined;
      this.settings.otherSettings.skuFileName = undefined;
      this.fileName = undefined;
    }
  }

  compareSKUCSVArrays(inputArray, tempArray) {
    const isArrEqual = inputArray.length == tempArray.length && inputArray.every(function (element, index) {
      return element === tempArray[index];
    });
    return isArrEqual;
  }

  validateCSVRows(data: any[]) {
    data.forEach(item => {
      if (item.repairabilityIndex) {
        //Check if cell value contains comma
        if (item.repairabilityIndex.indexOf(',') != -1) {
          var value = item.repairabilityIndex.split(',');
          var riDecimalValue = value[0].concat('.').concat(value[1]);
          this.repairabilityPositive = riDecimalValue >= 0 ? false : true;
          if (!this.repairabilityPositive) {
            this.isRepairabilitySizeError = riDecimalValue >= 10.1 ? true : false;
            if (this.isRepairabilitySizeError) this.riRangeErrorChecker++;
            if (item.repairabilityIndex.includes(',') && item.repairabilityIndex.split(',')[1].length >= 2) {
              item.repairabilityIndex = item.repairabilityIndex.substring(0, 3);
            }
          } else {
            this.riPositiveValueChecker++;
          }
        } else {
          this.repairabilityPositive = item.repairabilityIndex >= 0 ? false : true;
          if (!this.repairabilityPositive) {
            this.isRepairabilitySizeError = item.repairabilityIndex >= 10.1 ? true : false;
            if (this.isRepairabilitySizeError) this.riRangeErrorChecker++;
            if (item.repairabilityIndex.includes('.') && item.repairabilityIndex.split('.')[1].length >= 2) {
              item.repairabilityIndex = item.repairabilityIndex.substring(0, 3);
            }
          } else {
            this.riPositiveValueChecker++;
          }
        }
      }

      if (item.das_tete) {
        item.das_tete = this.validateDASWithCommas(item.das_tete, GlobalConstants.DAS_TETE_COL_NAME);
      }

      if (item.das_tronc) {
        item.das_tronc = this.validateDASWithCommas(item.das_tronc, GlobalConstants.DAS_TRONC_COL_NAME);
      }

      if (item.das_membre) {
        item.das_membre = this.validateDASWithCommas(item.das_membre, GlobalConstants.DAS_MEMBRE_COL_NAME);
      }
    });
  }

  validateDASWithCommas(cellValue, columnName) {
    //Check if cell value contains comma
    if (cellValue.indexOf(',') != -1) {
      var value = cellValue.split(',');
      var decimalVal = value[0].concat('.').concat(value[1]);
      cellValue = this.validateDASValues(decimalVal, columnName, cellValue);
    } else {
      cellValue = this.validateDASValues(cellValue, columnName);
    }
    return cellValue;
  }

  validateDASValues(dasVal, dasCol, value?) {
    let isValueNegative = dasVal >= 0 ? false : true;
    if (isValueNegative) {
      if (dasCol === GlobalConstants.DAS_TETE_COL_NAME) {
        this.dasTeteDecimalPointChecker++;
      } else if (dasCol === GlobalConstants.DAS_TRONC_COL_NAME) {
        this.dasTroncDecimalPointChecker++;
      } else this.dasMembreDecimalPointChecker++;
    } else {
      if (value != undefined && value.indexOf('.') == -1 && value == -0)
        value = '0';
    }
    return (value == undefined) ? dasVal : value;
  }

  //To Validate URL. existing method  which is used retailHQUser creation
  validateURL(event) {
    this.isURLValid = Utils.validateUrl(event.target.value);
  }
  // For UAT-464
  showMasterStatus(event) {
    this.showMasterPwdStatus = event;
  }
  showUninstallStatus(event) {
    this.showUnInstallPwdStatus = event;
  }
  generateTimeTimeZoneData(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.autoShutDownHour}:${data.autoShutDownMin} ${GlobalConstants.PST_TIME_ZONE}`;
    //Hardcoding TimeZone to PST so that already created profiles on EDIT will get changed TO PST
  }

  getTimeTimeZoneData(data) {
    this.enableTimeZone = data;
  }

  checkTimeZone(data) {
    this.isSettingsTimeZoneSelected = data;
  }

  getDefaultTimeZone(event) {
    this.sendDefaultTimeZone = event;
  }

  enableShutdown(event: any) {
    this.editPublishDateInfo = '';
    this.isSettingsTimeZoneSelected = true;
  }
  //To fecth all SKU's
  getAllSKU() {
    return new Promise((resolve, reject) => {
      this.skuIdService.getAllSkuInfoByUSer()
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(getAllSkuList => {
          this.skuList = getAllSkuList.skuContent;
          this.fetchedSKUs = this.skuList.map(e => e.skuID);
          this.selectAllForDropdownItems(this.skuList);
          resolve(this.skuList);
          this.skuList.forEach(ele => {
            ele.isSelected = this.isMasterSel;
          })
        });
    });
  }
  //On SKU select
  getSelectedSKU(event) { }

  // Function to return matched content on search.
  SKUSearchFn(term: string, item: any) {
    return item?.internalName?.toLocaleLowerCase()?.includes(term?.toLocaleLowerCase()) || item?.publishedName?.toLocaleLowerCase()?.includes(term?.toLocaleLowerCase());
  }

  //Function to prepare new SKU structure to profile 'skuList' structure. 
  getSlectedSKUSetData() {
    let skuListData = [];
    if (this.settings?.otherSettings?.selectedAllSKUs) {
      for (let i = 0; i < this.skuList?.length; i++) {
        let skuObj = { skuID: this.skuList[i]?.skuID, ...this.skuList[i]?.skuList };
        skuObj.skuCode = skuObj.publishedName; // renaming publishedName to skuCode
        delete skuObj.publishedName; //deleting publishedName
        if (skuObj?.priceStrikethrough === true || skuObj?.priceStrikethrough === "true") {
          skuObj.priceStrikethrough = "T";
        } else if (skuObj?.priceStrikethrough === false || skuObj?.priceStrikethrough === "false") {
          skuObj.priceStrikethrough = "F";
        }
        skuListData.push(skuObj);
      }
    } else {
      for (let i = 0; i < this.selectedSKUs?.length; i++) {
        let ind = this.skuList.findIndex(x => x.skuID === this.selectedSKUs[i]);
        if (ind !== -1) {
          let skuObj = { skuID: this.skuList[ind]?.skuID, ...this.skuList[ind]?.skuList };
          skuObj.skuCode = skuObj.publishedName; // renaming publishedName to skuCode
          delete skuObj.publishedName; //deleting publishedName
          if (skuObj?.priceStrikethrough === true || skuObj?.priceStrikethrough === "true") {
            skuObj.priceStrikethrough = "T";
          } else if (skuObj?.priceStrikethrough === false || skuObj?.priceStrikethrough === "false") {
            skuObj.priceStrikethrough = "F";
          }
          skuListData.push(skuObj);
        }
      }
    }
    return skuListData;
  }
  //Common function for excel download
  downloadExcel(data, filename) {
    const blob = new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename);
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  //To download old SKU with data
  downloadSKUData() {
    let headers = this.composeCSVHeaders();
    let csvData = Object.keys(this.composeCSVHeaders()).join(',')
    csvData += '\n';
    for (let i = 0; i < this.settings?.otherSettings?.oldSkuList?.length; i++) {
      for (let each in headers) {
        if (headers[each] != GlobalConstants.SKU_CODE_COLUMN) {
          csvData += ','
        }
        if (([0, 1, 2]).indexOf(headers[each]) >= 0) {
          csvData += this.settings?.otherSettings?.oldSkuList[i]?.promotionalContentIDs[headers[each]] ? this.settings?.otherSettings?.oldSkuList[i]?.promotionalContentIDs[headers[each]] : '';
        } else {
          csvData += this.settings?.otherSettings?.oldSkuList[i][headers[each]] ? this.settings?.otherSettings?.oldSkuList[i][headers[each]] : '';
        }
      }
      csvData += '\n';
    }

    this.downloadExcel(csvData, this.settings?.otherSettings?.skuFileName);
  }

  //To compose CSV Headers
  composeCSVHeaders() {
    let csvHeaders;
    if (this.isPriceSupress) {
      csvHeaders = {
        [GlobalConstants.SKU_CODE]: GlobalConstants.SKU_CODE_COLUMN,
        [GlobalConstants.BATTERY_LIFE]: GlobalConstants.BATTERY_LIFE_COLUMN,
        [GlobalConstants.SEGMENT_ID_CSV]: GlobalConstants.SEGMENT_ID_COLUMN,
        [GlobalConstants.PROMOCONTENT_1]: 0,
        [GlobalConstants.PROMOCONTENT_2]: 1,
        [GlobalConstants.PROMOCONTENT_3]: 2,
      };
    } else {
      csvHeaders = {
        [GlobalConstants.SKU_CODE]: GlobalConstants.SKU_CODE_COLUMN,
        [GlobalConstants.BATTERY_LIFE]: GlobalConstants.BATTERY_LIFE_COLUMN,
        [GlobalConstants.PRIMARY_PRICE]: GlobalConstants.PRIMARY_PRICE_COLUMN,
        [GlobalConstants.SECONDARY_PRICE]: GlobalConstants.SECONDARY_PRICE_COLUMN,
        [GlobalConstants.PRICE_STRIKETHROUGH]: GlobalConstants.PRICE_STRIKE_THROUGH,
        [GlobalConstants.SEGMENT_ID_CSV]: GlobalConstants.SEGMENT_ID_COLUMN,
        [GlobalConstants.PROMOCONTENT_1]: 0,
        [GlobalConstants.PROMOCONTENT_2]: 1,
        [GlobalConstants.PROMOCONTENT_3]: 2,
      };
    }

    if (this.isRepairabilityIndexEnabled) {
      Object.assign(csvHeaders, { [GlobalConstants.REPAIRABILITY_INDEX_COL_NAME]: GlobalConstants.REPAIRABILITY_INDEX });
      Object.assign(csvHeaders, { [GlobalConstants.DAS_TETE_COL_NAME]: GlobalConstants.DAS_TETE });
      Object.assign(csvHeaders, { [GlobalConstants.DAS_TRONC_COL_NAME]: GlobalConstants.DAS_TRONC });
      Object.assign(csvHeaders, { [GlobalConstants.DAS_MEMBRE_COL_NAME]: GlobalConstants.DAS_MEMBRE });
    }
    return csvHeaders;
  }

  //Function to check selected SKUS and fetched SKUS are equal.
  arrayEquals(a, b) {
    a.sort(); b.sort();
    return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index]);
  }

  selectAllForDropdownItems(items: any[]) {
    let allSelect = items => {
      items.forEach(element => {
        element['selectedAllGroup'] = 'selectedAllGroup';
      });
    };

    allSelect(items);
  }

  isSkuSelected(event) {
    console.log(this.skuList);
    if (this.skuList.length === event.length) {
      this.isAlldevicesSelected = true;
      this.settings.otherSettings.selectedAllSKUs = true;
    } else {
      this.isAlldevicesSelected = false;
      this.settings.otherSettings.selectedAllSKUs = false;
    }
  }

  scrollTabContentToTop(): void {
    const dropdown = this.elRef.nativeElement.querySelector('.ng-dropdown-panel-items');
    if (dropdown) {
      this.renderer.setProperty(dropdown, 'scrollTop', 0);
    }
  }

  onOpenSkuDropdown(isOpen: boolean) {
    if (isOpen && this.isAlldevicesSelected) {
      this.scrollTabContentToTop();
    }
  }

  getUploadedFile() {
    const url = AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
      + '/product-mapping/custom-packages/profiles/' + this.profileDataSet?.profileId + '/Product-Mapping';
    return this.httpMethodsservice.getImage(url, true)
      .pipe(map((res: any) => res)).subscribe(() => {
        this.PMFileExists = true;
        this.uploadedDate = this.profileDataSet.productMapLastUpdatedTime;
      });
  }
  
  uploadTemplate(fileInput: any) {
    this.showXlsxError = false;
    this.showFileContentError = false;
    let workBook = null;
    let jsonData = null;
    let dataString = null;
    const reader = new FileReader();
    const file = fileInput.target.files[0];
    this.fileName = fileInput.target.files[0].name.split('.')[0];
    const fileExtention = file.name.split('.').pop();
    reader.onload = (event) => {
      const data = reader.result;
      if ((fileExtention || '').toLowerCase() !== 'xlsx') {
        this.showXlsxError = true;
        return;
      } else {
        this.showXlsxError = false;
        workBook = XLSX.read(data, { type: 'binary' });
        const sheetNames = workBook.SheetNames;
        const expectedSheets = ['Laptop','Laptop_Test', 'Specifications', 'Message', 'DemoToScenario','Topics'];
        if (sheetNames) {
          for (let i = 0; i < sheetNames.length; i++) {
            if (!expectedSheets.includes(sheetNames[i])) {
              this.showFileContentError = true;
              return;
            }
          }
        } else {
          this.showFileContentError = false;
        }
      }
      this.checkMergeColumns(workBook);
      jsonData = {
        'DemoToScenario': this.llmExcelDemoJson,
        'Laptop': this.llmExcelLaptopJson,
        'Message': this.llmExcelMessagesJson,
        'Specifications': this.llmExcelSpecificationJson,
        'Topics': this.llmExcelTopicJson
      };
      dataString = JSON.stringify(jsonData);
      const url = AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
        + '/product-mapping/custom-packages/profiles/' + this.profileDataSet?.profileId;
      this.httpMethodsservice.putFile(url + '/ProductMapping', dataString, true)
        .pipe(map((res: any) =>
          res))
        .subscribe(() => {
          this.PMFileExists = true;
          this.file = fileInput.target.files[0];
          fileInput.target.value = null;
        });
      this.httpMethodsservice.putXFile(url + '/Product-Mapping', fileInput.target.files[0], fileExtention, true)
        .pipe(map((res: any) => res))
        .subscribe(() => {
          let PMDetails = {
            productMapConfiguration: this.profileDataSet?.profileId
          }
          this.cmnService.generateProductMapDetailsForProfiles(PMDetails).pipe(takeUntil(this.ngUnsubscribe)).pipe(first()).subscribe(response => {
            this.createProfileService.getProfileDetailsById(this.profileDataSet.profileId).subscribe(profileData => {
              this.uploadedDate = profileData?.profile.productMapLastUpdatedTime;
            });
          });
        });
    }
    reader.readAsBinaryString(file);
  }

  checkMergeColumns(data: any): void {
    for (let sheetNumber = 0; sheetNumber < data.SheetNames.length; sheetNumber++) {
      const wsname: string = data.SheetNames[sheetNumber];
      const ws: XLSX.WorkSheet = data.Sheets[wsname];

      if (ws['!merges']) {
        ws['!merges'].forEach((merge) => {
          const value = XLSX.utils.encode_range(merge).split(':')[0];
          for (let col = merge.s.c; col <= merge.e.c; col++) {
            for (let row = merge.s.r; row <= merge.e.r; row++) {
              ws[`${String.fromCharCode(65 + col)}${row + 1}`] = ws[value];
            }
          }
        });
      }
      if (sheetNumber == 0) this.llmExcelDemoJson = XLSX.utils.sheet_to_json(ws);
      if (sheetNumber == 1) this.llmExcelLaptopJson = XLSX.utils.sheet_to_json(ws);
      if (sheetNumber == 2) this.llmExcelMessagesJson = XLSX.utils.sheet_to_json(ws);
      if (sheetNumber == 3) this.llmExcelSpecificationJson = XLSX.utils.sheet_to_json(ws);
      if (sheetNumber == 4) this.llmExcelTopicJson = XLSX.utils.sheet_to_json(ws);
    }
  }

  downloadPMFile() {
    const initialTemplateUrl = environment.apiBaseUrlAsset + AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
    + '/product-mapping/custom-packages/SampleProductMapping.xlsx';
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', initialTemplateUrl);
    link.setAttribute('download','SampleProductMapping.xlsx');
    document.body.appendChild(link);
    link.click();
  }

  downloadModifiedTemplate() {
    const url = environment.apiBaseUrlAsset + AssetLibraryConstants.S3_ASSET_LIBRARY_RETAILERS + sessionStorage.getItem('retailerId')
    + '/product-mapping/custom-packages/profiles/' + this.profileDataSet?.profileId +'/Product-Mapping';
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', this.templateName);
    document.body.appendChild(link);
    link.click();
  }
}
